// extracted by mini-css-extract-plugin
export default {"input":"scalable-font-size-input__input___ZfVkj","text":"scalable-font-size-input__text___n1GGc"};